import type { Insurance } from "@/types/insurance/insurance";
import { toFixedNumber } from "../utils";

// Uførekapital (engangsstøtte til en person som er ufør)
export function disabilityCapitalCompensation(
	insurance: Insurance | undefined,
	age: number,
): number {
	let baseCoverageParam: number;
	let startAge: number;
	let maxAge: number;
	const BASE_REDUCTION = 0.025;
	let reduction: number;

	if (insurance === undefined || !insurance.type || insurance.type !== "disability-capital") {
		return 0;
	}

	try {
		baseCoverageParam = parseFloat(
			insurance?.params?.find((param) => param.type === "base-compensation")
				?.value as string
		);
		startAge = parseFloat(
			insurance?.params?.find((param) => param.type === "start-age")
				?.value as string
		);
		maxAge = parseFloat(
			insurance?.params?.find((param) => param.type === "max-age")
				?.value as string
		);
		reduction =
			parseFloat(
				insurance?.params?.find((param) => param.type === "reduction")
					?.value as string
			) / 100;
	} catch (error) {
		console.error("Error in disabilityCapitalCompensation:", error);
		return 0;
	}

	if (!baseCoverageParam || baseCoverageParam < 0) {
		return 0;
	}

	if (!startAge && startAge !== 0) {
		startAge = 25;
	}

	if (!maxAge) {
		maxAge = 60;
	}

	if (!reduction || reduction < 0) {
		reduction = BASE_REDUCTION;
	}

	// Validate age (age can be 0, so check explicitly)
	if (age === null || age === undefined || age < 0 || age >= maxAge) {
		return 0;
	}

	let sum = baseCoverageParam;

	// Between 0 and minAge: full compensation (no reduction)
	// Between minAge and maxAge: apply reduction linearly
	// After maxAge: compensation stays at the maxAge level (no further reduction)
	if (age > startAge && reduction > 0) {
		const yearsForReduction = Math.min(age - startAge, maxAge - startAge);
		sum = sum - sum * reduction * yearsForReduction;
	}

	// Ensure compensation doesn't go negative
	if (sum < 0) {
		return toFixedNumber(0);
	}

	return toFixedNumber(sum);
}
